// Shared scroll helpers. Lenis hijacks the native scroll, so anchor links
// must be routed through the Lenis instance (window.__lenis) to work reliably,
// especially on mobile where native scrollIntoView gets overridden.

export const HEADER_OFFSET = -84;

export const scrollToId = (id) => {
  const selector = id.startsWith("#") ? id : `#${id}`;
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: HEADER_OFFSET, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

// Preselect a service, scroll to the hero form and let ContactForm pick it up.
export const requestService = (service) => {
  window.dispatchEvent(new CustomEvent("preselect-service", { detail: service }));
  scrollToId("#hero");
};
